/**
 * Kontakty pro použití ve formulářích subjektu.
 */
export const AREA_ZR = "AREA_ZR";
export const AREA_ARES = "AREA_ARES";
export const AREA_ZR_ARES = "AREA_ZR_ARES";
